import { isClientAccountActive } from '../services/user'

export default {
  namespaced: true,
  state: () => ({
    subscriptionStatus: 'live',
    trialEndsIn: '',
    subscriptionList: [],
    selectedSubsciption: '',
    userDrawingTools: [],
    userIndicators:[]
   
  }),
  mutations: {
    AddUsedTool(state, toolId) {
      if(!state.userDrawingTools.includes(toolId))
      state.userDrawingTools.push(toolId)
    },
    ClearUsedTools(state) {
        state.userDrawingTools = [];
    },
    RemoveUsedTool(state) {
        state.userDrawingTools.pop();
    },
    AddUsedIndicator(state, indicatorId) {
       if (!state.userIndicators.includes(indicatorId)) {
         state.userIndicators.push(indicatorId);
       }
     },
    ClearUsedIndicators(state) {
        state.userIndicators = [];
     },
    SyncUsedIndicators(state, indicatorNames) {
         state.userIndicators = [...new Set(indicatorNames)];
     },

    updateSubscriptionState(state, data) {
      state.subscriptionStatus = data.status
      if (data.status === 'trialing') {
        state.trialEndsIn = data.trialEndsIn
      } else {
        state.trialEndsIn = ''
      }
      state.selectedSubsciption = data?.subscription_cancel_status
    },
    setSubscriptionList(state, data) {
      state.subscriptionList = data
    },
  },
  actions: {
    async retrieveUserSubscriptionStatus(context) {
      const isClientAccountAuthenticated = await isClientAccountActive()
      if (isClientAccountAuthenticated) {
        context.commit('setSubscriptionList', [isClientAccountAuthenticated])
        context.commit('updateSubscriptionState', isClientAccountAuthenticated)
        return { isSuccess: true, data: isClientAccountAuthenticated }
      } else {
        return { isSuccess: false, data: null }
      }
    },
  },
  getters: {
    subscriptionList: (state) => state.subscriptionList,
    subscriptionStatus: (state) => state.subscriptionStatus,
     userDrawingTools:(state) => state.userDrawingTools,
     userIndicators:(state)=>state.userIndicators
  },
}
